"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiToggleButton: {
        root: {
            textTransform: 'none',
            border: 'none',
            '&:not(:first-child)': {
                borderRadius: theme.shape.borderRadius,
            },
            '&:first-child': {
                borderRadius: theme.shape.borderRadius,
            },
            '&.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
            '&.Mui-selected:hover': {
                backgroundColor: `${theme.palette.primary.light} !important;`,
            },
        },
    },
    MuiToggleButtonGroup: {
        root: {
            border: `solid 1px ${theme.palette.divider}`,
        },
        grouped: {
            margin: theme.spacing(0.5),
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9nZ2xlYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL292ZXJyaWRlcy90b2dnbGVidXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxrQkFBZSxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDdkIsZUFBZSxFQUFFO1FBQ2YsSUFBSSxFQUFFO1lBQ0osYUFBYSxFQUFFLE1BQU07WUFDckIsTUFBTSxFQUFFLE1BQU07WUFDZCxxQkFBcUIsRUFBRTtnQkFDckIsWUFBWSxFQUFFLEtBQUssQ0FBQyxLQUFLLENBQUMsWUFBWTthQUN2QztZQUNELGVBQWUsRUFBRTtnQkFDZixZQUFZLEVBQUUsS0FBSyxDQUFDLEtBQUssQ0FBQyxZQUFZO2FBQ3ZDO1lBQ0QsZ0JBQWdCLEVBQUU7Z0JBQ2hCLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJO2dCQUMzQyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBWTthQUMxQztZQUNELHNCQUFzQixFQUFFO2dCQUN0QixlQUFlLEVBQUUsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFLLGNBQWM7YUFDOUQ7U0FDRjtLQUNGO0lBQ0Qsb0JBQW9CLEVBQUU7UUFDcEIsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUU7U0FDN0M7UUFDRCxPQUFPLEVBQUU7WUFDUCxNQUFNLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUM7U0FDM0I7S0FDRjtDQUNGLENBQUMsQ0FBQyJ9